import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import MainButton from "../components/MainButton";
import leftArrow from "../assets/icons/left-arrow.svg"
import JackpotImage from "../assets/images/2500-usdt-mini.svg";
import UsdtIcon from "../assets/icons/usdt-icon.svg";
import IncrementIcon from "../assets/icons/increment-icon.svg";
import DecrementIcon from "../assets/icons/decrement-icon.svg";
import SearchIcon from "../assets/icons/search-icon.svg"
import ButTicketIcon from "../assets/icons/buy-ticket-icon.svg";
import TicketIcon from "../assets/icons/ticket-icon.svg";
import TicketDisabledIcon from "../assets/icons/ticket-disabled-icon.svg";
import { Input, Spin, Switch } from "antd";
import CompleteModal from "../components/CompleteModal";
import {
    addressToHisReferrer, addUserToMlm,
    approveUSDT,
    buyMegaTickets,
    buyTickets,
    buyUniqueTicket,
    createOffer18Affiliate,
    createOffer18Offer,
    cycleCount,
    fetchOffer18Reports,
    getCookie,
    getSoldTicketCount,
    getTicketPrice,
    getTicketsStatus, getUserInfo,
    getUserMegaTickets, jackpotReward,
    megajackpotCircle, megaTicketsPrice, sendClickFromCookies, sendOffer18Conversion, startJackpot, userInfo, winningsTicket,
} from "../web3";
import { useWeb3Modal, useWeb3ModalAccount } from "@web3modal/ethers/react";
import { ethers } from 'ethers';
import { ABI } from "../ABI/ABI";
import { mUSDTABI } from "../ABI/mUSDTABI";
import { ApiClient } from "../utils/ApiClient";
import WinningsModal from "../components/WinningsModal";
import { useReferral } from "../routes/IndexRoute";


function Jackpot(data: any) {
    const { getWalletProvider }: any = useWeb3Modal(); // Получаем Web3Modal провайдер
    const [accessibleTicketsCount, setAccessibleTicketsCount] = useState();
    const [soldTicketsCount, setSoldTicketsCount] = useState();
    const [inputValue, setInputValue] = useState(1);
    const [totalCount, setTotalCount] = useState(5);
    const [allTickets, setAllTickets] = useState<any>([]);
    const [isChecked, setIsChecked] = useState<Boolean>(true);
    const [isNotTicket, setIsNotTicket] = useState<Boolean>(false);
    const [infoModalOpen, setInfoModalOpen] = useState(false);
    const [winningModalOpen, setWinningModalOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState<any>(false);
    const [allTicketsCount, setAllTicketsCount] = useState([]);
    const [ticketPrice, setTicketPrice] = useState<any>();
    const [tickets, setTickets] = useState();
    const [cycle, setCycle] = useState();
    const [megaCycle, setMegaCycle] = useState();
    const [megaJackpotTickets, setMegaJackpotTickets] = useState<any>();
    const [winningTickets, setWinningTickets] = useState<any>();
    const [jackpotRewards, setJackpotRewards] = useState<any>();
    const [disableBtn, setDisableBtn] = useState<any>(false);
    const referralId = useReferral();

    const { t } = useTranslation();
    const navigate = useNavigate();

    // const mUSDTAddress = "0x3051ee640D0A935BD181b0b81dde9d80998f4c15";
    // const contractAddress = "0x7283B47f40641F0C977F12bB87D5c1bEf0F1821E";



    const apiClient = new ApiClient("https://cryptolottery777.com/public/tickets/data");
    const apiClientJackpotWinning = new ApiClient("https://cryptolottery777.com/public/winningtickets/data");
    const apiClientJackpotNotifications = new ApiClient("https://cryptolottery777.com/public/jackpot/notifications/data");


    useEffect(() => {

        getTicketPrice().then((res: any) => {
            let price: any = Number(res)
            setTicketPrice(price)
        });
        cycleCount().then((res: any) => {
            setCycle(res)
        });
        megajackpotCircle().then((res: any) => {
            setMegaCycle(res)
        })

    }, [ticketPrice, data?.address]);


    const generateArray = () => {
        let newArr: any = []
        getTicketsStatus().then(arr => {
            for (let i = 1; i < arr.length; i++) {
                let item = {
                    ticket_number: [i].toString(),
                    is_active: !arr[i]
                }
                newArr.push(item)
            }
            setAllTickets(newArr);
        })
    }



    useEffect(() => {
        generateArray()
        getSoldTicketCount().then((res: any) => {

            setSoldTicketsCount(res[0]);
            setAllTicketsCount(res[1])
            let accessibleCount: any = res[1] - res[0];
            setAccessibleTicketsCount(accessibleCount);
        })
    }, [isChecked, infoModalOpen]);




      const test = ()=>{
        startJackpot()
      }

    const handleInputValue = (e: any) => {
        let inputCount: any = Number(e.target.value)
        if (inputCount <= allTicketsCount && inputCount >= 0) {
            let totalPriceInUsdt = inputCount * 5
            setInputValue(inputCount)
            setTotalCount(totalPriceInUsdt)
        }
    };
    const handleDecrement = () => {
        if (Number(inputValue) > 1) {
            let decrementValue: any = Number(inputValue) - 1;
            let totalPriceInUsdt = decrementValue * 5
            setInputValue(decrementValue);
            setTotalCount(totalPriceInUsdt)
        }
    };
    const handleIncrement = () => {
        if (Number(inputValue) < Number(allTicketsCount)) {
            let incrementValue: any = Number(inputValue) + 1;
            let totalPriceInUsdt = incrementValue * 5
            setInputValue(incrementValue);
            setTotalCount(totalPriceInUsdt)
        }
    };

    // const winningJackpotTicketsRewards = async () => {
    //     try {
    //         const res: any = await getSoldTicketCount();


    //         let fetchWinningData: any = {
    //             tickets: [],
    //             ticketPrice: ticketPrice,
    //             cycle: cycle,
    //             winnings: []
    //         };

    //         if (res[0] === res[1]) {
    //             await startJackpot()
    //             apiClientJackpotNotifications.post({}).then(res => {

    //             });
    //             setWinningModalOpen(true)

    //             try {
    //                 const [tickets, winnings] = await Promise.all([
    //                     winningsTicket(),
    //                     jackpotReward()
    //                 ]);

    //                 fetchWinningData.tickets = tickets;
    //                 fetchWinningData.winnings = winnings;

    //                 const response = await apiClientJackpotWinning.post(fetchWinningData);

    //             } catch (error) {
    //                 console.error("Error fetching winnings data:", error);
    //             }
    //         }
    //     } catch (error) {
    //         console.error("Error fetching sold ticket count:", error);
    //     }
    // }

    // const winningJackpotTicketsRewards = async () => {
    //     try {
    //         const res: any = await getSoldTicketCount();

    //         let fetchWinningData: any = {
    //             tickets: [],
    //             ticketPrice: ticketPrice,
    //             cycle: cycle,
    //             winnings: []
    //         };

    //         if (res[0] === res[1]) {
    //             await startJackpot();

    //             apiClientJackpotNotifications.post({}).then(res => {});

    //             setWinningModalOpen(true);

    //             try {
    //                 const [tickets, winnings] = await Promise.all([
    //                     winningsTicket(),
    //                     jackpotReward()
    //                 ]);

    //                 fetchWinningData.tickets = tickets;
    //                 fetchWinningData.winnings = winnings;

    //                 const isValid =
    //                     Array.isArray(fetchWinningData.tickets) && fetchWinningData.tickets.length > 0 &&
    //                     Array.isArray(fetchWinningData.winnings) && fetchWinningData.winnings.length > 0 &&
    //                     typeof fetchWinningData.ticketPrice === 'number' && fetchWinningData.ticketPrice > 0 &&
    //                     typeof fetchWinningData.cycle !== 'undefined';

    //                 if (isValid) {
    //                     setLoading(true); // Показываем loader перед отправкой
    //                     const response = await apiClientJackpotWinning.post(fetchWinningData);
    //                     console.log("✅ Данные победителей успешно отправлены:", response.data);
    //                     setLoading(false); // Скрываем loader после ответа
    //                     return response.data;
    //                 } else {
    //                     console.warn("⚠️ Данные для отправки невалидны:", fetchWinningData);
    //                 }

    //             } catch (error) {
    //                 setLoading(false); // Скрываем loader при ошибке
    //                 console.error("❌ Ошибка при получении данных выигрышей:", error);
    //             }
    //         }

    //     } catch (error) {
    //         console.error("❌ Ошибка при получении количества проданных билетов:", error);
    //     }
    // };

    const winningJackpotTicketsRewards = async () => {
        // Функция предотвращения обновления страницы
        const preventUnload = (e: BeforeUnloadEvent) => {
            e.preventDefault();
            e.returnValue = '';
        };

        try {
            const res: any = await getSoldTicketCount();

            let fetchWinningData: any = {
                tickets: [],
                ticketPrice: ticketPrice,
                cycle: cycle,
                winnings: []
            };

            if (res[0] === res[1]) {
                await startJackpot();
                // Уведомление (без ожидания)
                apiClientJackpotNotifications.post({}).then(res => { });

                // Открываем модалку и включаем лоадер
                setWinningModalOpen(true);
                setLoading(true);
                window.addEventListener("beforeunload", preventUnload); // ⛔ Блокируем обновление

                try {
                    // Получаем билеты и выигрыши параллельно
                    const [tickets, winnings] = await Promise.all([
                        winningsTicket(),
                        jackpotReward()
                    ]);

                    fetchWinningData.tickets = tickets;
                    fetchWinningData.winnings = winnings;

                    const isValid =
                        Array.isArray(fetchWinningData.tickets) && fetchWinningData.tickets.length > 0 &&
                        Array.isArray(fetchWinningData.winnings) && fetchWinningData.winnings.length > 0 &&
                        typeof fetchWinningData.ticketPrice === 'number' && fetchWinningData.ticketPrice > 0 &&
                        typeof fetchWinningData.cycle !== 'undefined';

                    if (isValid) {
                        const response = await apiClientJackpotWinning.post(fetchWinningData);
                        console.log("✅ Данные победителей успешно отправлены:", response.data);

                        return response.data;
                    } else {
                        console.warn("⚠️ Данные для отправки невалидны:", fetchWinningData);
                    }

                } catch (error) {
                    console.error("❌ Ошибка при получении данных выигрышей:", error);

                } finally {
                    // Обязательно снимаем защиту и выключаем лоадер
                    window.removeEventListener("beforeunload", preventUnload);
                    setLoading(false);
                }
            }

        } catch (error) {
            console.error("❌ Ошибка при получении количества проданных билетов:", error);
        }
    };


 

    const handleBuyJackpotTicket = async () => {
        sendClickFromCookies()
        if (!disableBtn) {
            try {
                setLoading(true);
                if (data?.isConnected) {
                    let referrer_address = referralId;
                    const affSub2 = getCookie("aff_sub2");

                    // 1. Приоритет — cookie
                    if (affSub2) {
                        referrer_address = String(affSub2);
                        console.log("Ref from cookie:", referrer_address);

                    }
                    // 2. Проверяем ссылку вида https://.../#/адрес
                    else if (window.location.hash && window.location.hash.startsWith("#/")) {
                        const urlRef = window.location.hash.replace("#/", "").trim();
                        if (urlRef && /^0x[a-fA-F0-9]{40}$/.test(urlRef)) {
                            referrer_address = urlRef;
                            console.log("Ref from URL:", referrer_address);

                        }
                    }
                    // 3. Если referralId === "newID"
                    else if (referrer_address === "newID") {
                        referrer_address = "0xb5bbedb0ceffeb4287a6caa5910966dad2de2b20";
                        // referrer_address = "0x23F177D15F962377e66F9Bb2De821C7156996DD5";
                        console.log("Ref from newID:", referrer_address);

                    }
                    // 4. fallback
                    else {
                        referrer_address = referralId;
                    }

                    try {
                        console.log("ref_address",referrer_address);
                        addressToHisReferrer(data?.address).then((res) => {
                            
                            if (res.toLowerCase() === "0x0000000000000000000000000000000000000000") {
                                console.log("ref_address",referrer_address);
                                getUserInfo(referrer_address).then((res) => {
                                    setTickets(res?.ticketsArr)
                                    let referrerID = Number(res?.addressId);

                                    console.log("data address", data?.address);

                                    let mlmResponse = addUserToMlm(data?.address, referrerID);
                                })
                            }
                            console.log("ref_address after if",referrer_address);
                        })
                    } catch (error) {
                        localStorage.removeItem("ref");
                        console.error("Error in handleBuyJackpotTicket:", error);
                    }
                }
                console.log('tc',totalCount);
                
                approveUSDT(totalCount, data.provider).then((res => {
                    try {
                        buyTickets(Number(inputValue), data?.provider).then((res) => {
                            if (res) {
                                getUserInfo(data?.address).then(async (res) => {
                                    var fetchData: any = {
                                        walletAddress: data?.address,
                                        tickets: res?.ticketsArr,
                                        ticketPrice: ticketPrice,
                                        cycle: cycle,
                                    };

                                    apiClient.post(fetchData).then(() => { });
                                    await sendOffer18Conversion(Number(inputValue));
                                });

                                winningJackpotTicketsRewards();

                                setLoading(false);
                                setInputValue(1);
                                setTotalCount(ticketPrice);
                                setIsError(false);
                                setInfoModalOpen(true);
                                getTicketPrice();
                            } else {
                                setLoading(false);
                                setInputValue(1);
                                setTotalCount(ticketPrice);
                                setIsError(true);
                                setInfoModalOpen(true);
                            }
                        });
                    } catch (e) {
                        setLoading(false);
                        setInputValue(1)
                        setTotalCount(ticketPrice)
                        setIsError(true)
                        setInfoModalOpen(true);
                    }
                }))
            } catch (error) {
                console.error("Error during purchase process:", error);
                setLoading(false);

                setInputValue(1)
                setTotalCount(ticketPrice)
                setIsError(true)
                setInfoModalOpen(true);
            }
        } else return
    };



    const buyLuckyTicket = async (ticket: any) => {
        sendClickFromCookies()
        if (ticket.is_active) {
            try {
                setLoading(true);

                if (data?.isConnected) {


                    let referrer_address: any = localStorage.getItem('ref');


                    if (referrer_address?.endsWith('/')) {


                        referrer_address = referrer_address.slice(0, -1);
                    } else
                        console.log("else");

                    referrer_address = "0x5478355B05384Ed86E420A83C1FD05D813FE929d"
                    // referrer_address = "0x23F177D15F962377e66F9Bb2De821C7156996DD5"
                    try {

                        addressToHisReferrer(data?.address).then((res) => {

                            if (res.toLowerCase() === "0x0000000000000000000000000000000000000000") {

                                getUserInfo(referrer_address).then((res) => {
                                    let referrerID = Number(res?.addressId);

                                    let mlmResponse = addUserToMlm(data?.address, referrerID);

                                })
                            }
                        })
                    } catch (error) {
                        console.error("Error in handleBuyJackpotTicket:", error);
                    }
                }
                approveUSDT(totalCount, data.provider).then((res => {
                    try {
                        buyUniqueTicket(ticket?.ticket_number, data?.provider).then((res) => {
                            if (res) {
                                sendOffer18Conversion(1)
                                getUserInfo(data?.address).then((res) => {

                                    var fetchData: any = {
                                        walletAddress: data?.address,
                                        tickets: res.ticketsArr,
                                        ticketPrice: ticketPrice,
                                        cycle: cycle,
                                    };

                                    apiClient.post(fetchData).then(res => {

                                    });

                                });
                                // getUserMegaTickets(data?.address).then(res => {
                                //     const numArray = res[0]?.split(',')
                                //     console.log("megaTickets", numArray);
                                //
                                //     var fetchMegaJackpotData: any = {
                                //         walletAddress: data?.address,
                                //         tickets: numArray,
                                //         ticketPrice: ticketPrice,
                                //         cycle: megaCycle,
                                //     };
                                //     console.log("fetchDATAMega", fetchMegaJackpotData);
                                //
                                //     apiClientMega.post(fetchMegaJackpotData).then(res => {
                                //         console.log("post-mega", res)
                                //     });
                                // });
                                winningJackpotTicketsRewards()

                                setLoading(false);
                                setInputValue(1)
                                setTotalCount(ticketPrice)
                                setIsError(false)
                                setInfoModalOpen(true);
                                getTicketPrice()
                            } else {
                                setLoading(false);
                                setInputValue(1)
                                setTotalCount(ticketPrice)
                                setIsError(true)
                                setInfoModalOpen(true);
                            }
                        });
                    } catch (e) {
                        setLoading(false);
                        setInputValue(1)
                        setTotalCount(ticketPrice)
                        setIsError(true)
                        setInfoModalOpen(true);
                    }
                }
                ))
            } catch (error) {
                setLoading(false);
                setIsError(true)
                setInfoModalOpen(true);
                console.error("Error during purchase process:", error);
            }
        }
    };

    const onSwitchChange = (checked: boolean) => {

        if (checked) {

            let availableTickets = allTickets.filter(((ticket: any) => ticket.is_active === true))
            setAllTickets(availableTickets)
        } else {
            setIsChecked(!isChecked);
        }
    };

    const handleSearchNumber = (event: any) => {

        let number = event.target.value
        if (Number(number) >= 0 && Number(number) <= 777) {
            setIsNotTicket(false)
            if (number.length) {

                // let allNumbers = generateArray()
                let newArr: any = []
                getTicketsStatus().then(arr => {
                    for (let i = 1; i < arr.length; i++) {
                        let item = {
                            ticket_number: [i].toString(),
                            is_active: !arr[i]
                        }
                        newArr.push(item)
                    }
                    // console.log("NEWARR",newArr)
                    let searchNumber = newArr.filter((ticket: any) => ticket.ticket_number === number)

                    setAllTickets(searchNumber)
                })
            } else setIsChecked(!isChecked)
        } else setIsNotTicket(true)
    }

    return (
        <>
            {loading ? <Spin fullscreen={true} size="large" /> :
                <div className="jackpot">
                    <div className="jackpot_title">
                        <img src={leftArrow} alt="icon" width={32} height={32} onClick={() => {
                            navigate('/')
                        }} />
                        <span>{t('Джекпот')}</span>
                    </div>
                    <div className="jackpot_info">
                        <div className="jackpot_info__price">
                            <img src={UsdtIcon} alt="icon" />
                            <span className="jackpot_info__price___unit-price">{ticketPrice / 10**18} USDT</span>
                            <span className="jackpot_info__price___text">{t('за билет')}</span>
                        </div>
                        <div className="jackpot_info__tickets-count">
                            <div className="jackpot_info__tickets-count___item">
                                <div className="jackpot_info__tickets-count___item____title">{t('Всего билетов')}</div>
                                <div className="jackpot_info__tickets-count___item____count">{allTicketsCount}</div>
                            </div>
                            <div className="jackpot_info__tickets-count___item">
                                <div className="jackpot_info__tickets-count___item____title">{t('Доступный')}</div>
                                <div
                                    className="jackpot_info__tickets-count___item____count">{accessibleTicketsCount}</div>
                            </div>
                            <div className="jackpot_info__tickets-count___item">
                                <div className="jackpot_info__tickets-count___item____title">{t('Проданный')}</div>
                                <div className="jackpot_info__tickets-count___item____count">{soldTicketsCount}</div>
                            </div>
                        </div>
                        <img src={JackpotImage} alt="icon" className="jackpot_info__logo" />
                    </div>
                    <div className="buy-ticket-block">
                        <div className="buy-ticket-block_header">
                            <div className="buy-ticket-block_header__title">
                                {t('Количество билетов')}
                            </div>
                            <div className="buy-ticket-block_header__subtitle">
                                {t('Вы можете выбрать количество билетов с номерами, которые будут присвоены случайным образом.')}
                            </div>
                        </div>
                        <div className="ticket-count-input">
                            <img src={DecrementIcon} alt="icon" onClick={handleDecrement} />
                            <input
                                type="text"
                                className="ticket-count-input_count"
                                value={inputValue}
                                onChange={handleInputValue}
                            />
                            <img src={IncrementIcon} alt="icon" onClick={handleIncrement} />
                        </div>
                        <div className="buy-ticket-block_btn">
                            <MainButton
                                icon={ButTicketIcon}
                                text={'Купить билет за'}
                                price={totalCount}
                                func={handleBuyJackpotTicket}
                            />
                        </div>
                    </div>
                    <div className="choose-number-block">
                        <div className="buy-ticket-block_header">
                            <div className="buy-ticket-block_header__title">
                                {t('Ваш счастливый номер')}
                            </div>
                            <div className="buy-ticket-block_header__subtitle">
                                {t('Выберите номер из 1-777 и получите билет на свой счастливый номер.')}
                            </div>
                        </div>
                        <div className="choose-number-block_filter">
                            <Input
                                className="choose-number-block_filter__search-ticket-number"
                                placeholder={t("Поиск номера билета")}
                                prefix={<img src={SearchIcon} alt="icon" />}
                                onInput={handleSearchNumber}
                            />
                            <div className="choose-number-block_filter__switch">
                                <span>{t('Только доступные')}</span>
                                <Switch
                                    onChange={onSwitchChange}
                                    className="switcher"
                                />

                            </div>
                        </div>
                        <div className="choose-number-block_tickets">
                            {!isNotTicket ?
                                <>{allTickets?.map((ticket: any) => {
                                    return (
                                        <div className="choose-number-block_tickets__item" key={ticket.ticket_number}
                                            onClick={() => buyLuckyTicket(ticket)}>
                                            {ticket.is_active ?
                                                <img src={TicketIcon} alt="Snow" width={40} height={40} /> :
                                                <img src={TicketDisabledIcon} alt="Snow" width={40} height={40} />}
                                            <div
                                                className={ticket.is_active ? "choose-number-block_tickets__item___number" : "choose-number-block_tickets__item___number disabled"}
                                            >
                                                {ticket.ticket_number}
                                            </div>
                                        </div>
                                    )
                                })}</> :
                                <div className="choose-number-block_tickets__error">
                                    <span>{t('Неверный номер, попробуйте искать до номера 777.')}</span>
                                </div>}
                        </div>
                    </div>
                    <CompleteModal
                        infoModalOpen={infoModalOpen}
                        setInfoModalOpen={setInfoModalOpen}
                        isError={isError}
                    />
                    <WinningsModal
                        winningModalOpen={winningModalOpen}
                        setWinningModalOpen={setWinningModalOpen}
                        walletAddress={data?.address}
                    />

                </div>}
        </>
    )
}

export default Jackpot
function getQueryParam(arg0: string) {
    throw new Error("Function not implemented.");
}

